<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Ajouter un mouvement</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="mouvementForm" @submit="addMouvement" :validation-schema="mouvementSchema">
        <div class="row">
          <div class="col-md-12 mb-3">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                    Magasin
                </label>
                <Multiselect
                  :options="magasinOptions"
                  :searchable="true"
                  track-by="label"
                  label="label"
                  v-model="magasin"
                  placeholder="Sélectionner le magasin"
                  @select="selectMag(magasin)"/>
              </div>
          </div>
          <div class="col-md-12 mb-md-25">
                <div class="border border-primary mb-10">
                  <div class="  d-flex align-items-center justify-content-between fw-bold p-2"
                    style="background-color: #0a59a4">
                    <div class="col-md-7">
                      <h3 class="fs-4 text-white">{{ magasinss? magasinss:"Magasin" }}</h3>
                    </div>
                    <div class="col-md-5">
                      <div class="d-flex float-end">
                        <button
                          class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                          type="button" :class="{ 'cursor-not-allowed': isDisable }" @click="addRowMouvement()">
                          <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                          Ajouter un produit
                        </button>
                        <router-link to="/liste-mouvements"></router-link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="row gx-2 p-2 d-flex align-items-center justify-content-between mt-10">
                      <div class="col-md-3">
                        <label class="d-block text-black fw-semibold mb-10">
                          Produit <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                          <label class="d-block text-black fw-semibold mb-10">
                            Type Operation<span class="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <label class="d-block text-black fw-semibold">
                          Quantité
                          <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col-md-2">
                        <label class="d-block text-black fw-semibold">
                          Motif
                          <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col-md-2">
                        <label class="d-block text-black fw-semibold">
                          Reférence
                          <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col-md-1">
                        <label class="d-block text-black fw-semibold mb-10">Actions</label>
                      </div>
                    </div>
                    <hr class="mt-0" />
                    <div class="row gx-2 px-2" v-for="(mouvement, index) in mouvements" :key="index">
                      <div class="col-md-3 mb-2">
                        <div class="form-group ">
                          <Multiselect :close-on-select="true" :options="produitOptions" :searchable="true" :disabled="isDis"
                            :multiple="false" v-model="mouvement.proCondiMagInventaire" placeholder="Sélectionner les produits" />
                          <span class="text-danger" v-if="valideteRowMouvement(mouvement.proCondiMagInventaire)"></span>
                          <span class="text-danger" v-if="validateDupliacat(mouvement.proCondiMagInventaire)">Ce produit a été déjà selectionné</span>
                        </div>
                      </div>
                      <div class="col-md-2 mb-2">
                        <div class="form-group ">
                            <Multiselect :searchable="true" :options="lestypes" v-model="mouvement.typeOperation"
                              placeholder="Choisir" />
                          <span class="invalid-feedback" v-if="valideteRowMouvement(mouvement.typeOperation)"></span>
                        </div>
                      </div>npm 
                      <div class="col-md-2 mb-2">
                        <div class="form-group">
                          <input v-model="mouvement.qte" type="number"
                            class="form-control shadow-none fs-md-15 text-black" placeholder="saisir qte" />
                          <div class="invalid-feedback" v-if="valideteRowMouvement(mouvement.qte)">
                            La quantité est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 mb-2">
                        <div class="form-group ">
                          <Multiselect  :options="motifSuiviOptions" :searchable="true"
                            v-model="mouvement.motifsSuivi" placeholder="Choisir" />
                          <span class="invalid-feedback" v-if="valideteRowMouvement(mouvement.motifsSuivi)"> Le motif est obligatoire</span>
                        </div>
                      </div>
                      <div class="col-md-2 mb-2">
                        <div class="form-group ">
                          <input v-model="mouvement.refMov" type="text"
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Reférence" />
                            <div class="invalid-feedback" v-if="valideteRowMouvement(mouvement.refMov)">
                              La référence est obligatoire
                            </div>
                        </div>
                      </div>
                      <div class="col-md-1 mb-2">
                        <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                          @click="removeRowMouvement(index)">
                          <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                        </button>
                      </div>
                    </div>
                  </div>
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center ">
              <button class="btn btn-success me-3" type="submit" :disabled="isDisable">
                Ajouter un mouvement
              </button>
              <router-link to="/inventaires/liste-mouvements" class=" btn btn-danger "><i
                  class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { Form, Field, ErrorMessage, useFieldArray } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, format_date, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect/src/Multiselect';

export default defineComponent({
  name: "AddMouvement",
  components: {
    Form,
    Field,
    Multiselect
  },

  setup: () => {
    const mouvementSchema = Yup.object().shape({
      // mouvements: Yup.array().of(
      //   Yup.object().shape({
      //     type: Yup.string().required("Le type d'opération est obligatoire."),
      //     qte: Yup.number().required("La quantité est obligatoire.").min(1, "La quantité doit être supérieure à 0."),
      //     produit: Yup.number().min(1, "Au moins un produit doit être sélectionné.").required("Le produit est obligatoire."),
      //   })
      // )
    });

    const fetchMagasins = async () => {
      try {
        const response = await ApiService.get("/all/all/magasins");
        const magasinsData = response.data.data;
        magasinOptions.value = magasinsData.map((magasin) => ({
          value: magasin.id + "|" + magasin.nomMagasin,
          label: magasin.code + ' - ' + magasin.nomMagasin + ' du ' + magasin.magasin.nomMagasin,
        }));
      } catch (error) {
        //
      }
    };
    const isDis =  ref(true);

    const inventaireOptions = ref([]);
    const inventaire = ref("");
    const mouvementForm = ref(null);
    const router = useRouter();

    const magasinOptions = ref([]);
    const produitOptions = ref([]);
    const motifSuiviOptions = ref([]);
    const isDisable = ref(true);
    const magasinss = ref("");
    
    const mouvements = reactive([
      {
        typeOperation:'',
        qte: 0,
        motifsSuivi:0,
        refMov:'',
        proCondiMagInventaire: 0 
      }
    ]);

    const addRowMouvement = () => {
      mouvements.push({
        typeOperation:'',
        qte: null,
        motifsSuivi:0,
        refMov:'',
        proCondiMagInventaire: 0 // Modifié
      });
      console.log("Le contenu de Mouvements est celui là ===> ", mouvements);
    };

    const removeRowMouvement = (produitIndex) => {
      mouvements.splice(produitIndex, 1);
    };
    const valideteRowMouvement = (e) => {
      if (e === null || e === undefined || e === "" || e === 0) {
        return true; // Champs invalides
      } else {
        return false; // Champs valides
      }
    };

    const validateDupliacat = (e) => {
      return mouvements.filter((element) => element.proCondiMagInventaire === e).length > 1;
    };

    watch(mouvements, (newValue) => {
      isDisable.value = newValue.some(mouvement =>
        mouvement.qte < 1 || 
        mouvement.typeOperation === '' || 
        mouvement.proCondiMagInventaire < 0 ||
        mouvement.motifsSuivi < 0 ||
        mouvement.refMov === ''
      );
    }, { deep: true });


  const fetchMotifSuivi = async () => {
    try {
      const response = await ApiService.get("/all/motifSuivis");
      const invData = response.data.data.data;
      console.log(response.data.data,"invDatainvDatainvData");
      motifSuiviOptions.value = invData.map((inv) => ({
        value: inv.id,
        label: `${inv.libelle}`,
      }));
    } catch (error) {
      //
    }
  };

  
  const magasin = ref();

  const selectMag = (selectedMagasin) => {
  console.log(selectedMagasin,"selectedMagasinselectedMagasinselectedMagasin")
  if(selectedMagasin != null && selectedMagasin != undefined){
    fetchProduits(selectedMagasin.split("|")[0]);
      if(selectedMagasin.split("|")[0]){
        isDis.value=false;
      }else{
        isDis.value=true;
      }
  }
};
    
const fetchInventaire = async () => {
      try {
        const response = await ApiService.get("/inventaires/statut/1");
        const invData = response.data.data;
        console.log(response.data.data);
        inventaireOptions.value = invData.map((inv) => ({
          value: inv.id,
          label: `${inv.refInventaire} [${format_date(inv.dateDebut)} - ${format_date(inv.dateFin)}]- ${inv.magasin.nomMagasin}`,
        }));
      } catch (error) {
        //
      }
};

    async function getAllInventaireById(id) {
     await  ApiService.get(`/inventaires/`+id)
          .then(({ data }) => {
            magasinss.value = data.data.magasin.nomMagasin;
            produitOptions.value = data.data.inventaiprocondimags.map((produit) => ({
              value: produit.id,
              label: `${produit.nomProd}`,
            }));
          })
          .catch(({ response }) => {
            error(response.data.message)
        });
    }

    const fetchProduits = async (magasin) => {
      try {
        const response = await ApiService.get("/all/proCondiMagInventaires/"+magasin);
        const produitsData = response.data.data;
        console.log(produitsData,"produitsDataproduitsDataproduitsDataproduitsData");
        produitOptions.value = produitsData.map((produit) => ({
          value:produit.id,
          label:`${produit.nomProd}`,
        }));
        console.log(produitOptions.value,"response.data.data");
      } catch (error) {
        //
        console.log(error,"errorerrorerror")
      }
    };

    const lestypes = ref([
      { value: "Entrée", label: "Entrée" },
      { value: "Sortie", label: "Sortie" }
    ]);


    const addMouvement = async () => {
      if (!mouvementForm.value) return;
      const isValid = await mouvementForm.value.validate();
      if (isValid) {
        console.log(mouvements.values,"ffffffffffffff")
        try {
          await ApiService.post('/suivi', mouvements);
          success("Mouvement ajouté avec succès");
          router.push({name:"ListeMouvement"});
        } catch (err) {
          error("Erreur lors de l'ajout du mouvement");
          console.error(err);
        }
      }
    };

    const selectInventaire = (selectedMagasin) => {
      if(selectedMagasin) {
        //produits.length = 0;
        getAllInventaireById(selectedMagasin);
      }
    };

   

    onMounted(async () => {
      //fetchInventaire();
      fetchMotifSuivi();
      fetchMagasins();
    });

    return {
      mouvements,
      addRowMouvement,
      removeRowMouvement,
      magasin,
      selectMag,
      inventaireOptions,
      addMouvement,
      inventaire,isDis,
      selectInventaire,
      mouvementForm,
      magasinOptions,
      motifSuiviOptions,
      produitOptions,
      lestypes,
      magasinss,
      valideteRowMouvement,
      validateDupliacat,
      isDisable,
      mouvementSchema
    };
  },
});
</script>

<style scoped>
/* Ajoutez votre style ici si nécessaire */
</style>
